<div class="d-flex flex-column">
    <div class="d-flex block-header" [class.header-block-margin]="isHeaderMargin">
        {{ blockHeader }}
    </div>
    <div class="d-flex block-content flex-column">
        <ng-content></ng-content>
    </div>
</div>
